"use client";
import o, { useRef as b, useState as y, useEffect as k } from "react";
import h from "./index.es59.js";
const E = h.div`
  position: relative;
  ul {
    display: none;
    border: solid 1px black;
    border-top: none;
    background: #fff;
    z-index: 1;
    li {
      display: block;
      padding: 1rem;
    }
    li:focus {
      outline: none;
      background: #f6f6f3;
    }
  }
  &:focus-within {
    ul {
      display: block;
    }
  }
`, w = h.ul`
  position: absolute;
  max-height: 300px;
  overflow: auto;
  width: 100%;
  li {
    cursor: pointer;
  }
`, x = (t) => {
  t.currentTarget.focus();
}, D = ({
  choices: t,
  onSelect: f,
  name: p,
  focused: c
}) => {
  const l = b(null), i = (n, e) => {
    const r = t.find((g) => g.value === n);
    r && (f(r), e.blur());
  }, a = (n) => {
    if (l && l.current) {
      const e = l.current.querySelector(
        `[data-code="${n}"]`
      );
      e && e.focus();
    }
  }, u = (n) => {
    const e = t.findIndex((r) => r.value === n);
    e >= 0 && e < t.length - 1 && a(t[e + 1].value), e === -1 && t.length && a(t[0].value);
  }, s = (n) => {
    const e = t.findIndex((r) => r.value === n);
    e > 0 && a(t[e - 1].value);
  };
  k(() => {
    c && l && l.current && a(c);
  }, [c, t]);
  const m = (n) => (e) => {
    i(n, e.currentTarget);
  }, d = (n) => (e) => {
    e.key === "ArrowDown" && (u(n), e.preventDefault()), e.key === "ArrowUp" && (s(n), e.preventDefault());
  }, v = (n) => (e) => {
    e.key === "Enter" && i(n, e.currentTarget);
  };
  return /* @__PURE__ */ o.createElement(o.Fragment, null, t.length > 0 && /* @__PURE__ */ o.createElement(w, { ref: l }, t.map((n, e) => /* @__PURE__ */ o.createElement(
    "li",
    {
      key: `${p}-${n.value}-${e}`,
      "data-code": n.value,
      onClick: m(n.value),
      onKeyPress: v(n.value),
      onKeyDown: d(n.value),
      onMouseEnter: x,
      tabIndex: 0
    },
    n.display
  ))));
}, S = (t) => {
  const { generateChoices: f, onChange: p, name: c, label: l, ...i } = t, a = b(null), [u, s] = y([]), [m, d] = y(), v = (r) => {
    s(f(r.currentTarget.value));
  }, n = (r) => {
    u.find((g) => g === r) && a.current && (a.current.value = "", p(r), s([]));
  }, e = (r) => {
    r.key === "ArrowDown" && u && u.length ? (d(u[0].value), r.preventDefault()) : d(void 0);
  };
  return /* @__PURE__ */ o.createElement(E, null, /* @__PURE__ */ o.createElement("label", { className: "bl-size-6" }, l, /* @__PURE__ */ o.createElement(
    "input",
    {
      ref: a,
      type: "text",
      className: "bl-input",
      onChange: v,
      onKeyDown: e,
      ...i
    }
  )), /* @__PURE__ */ o.createElement(
    D,
    {
      name: c,
      choices: u,
      onSelect: n,
      focused: m
    }
  ));
};
export {
  S as default
};
//# sourceMappingURL=index.es21.js.map
